import { PageViewEventLogger } from '@repo/tracking-service';

import { useSectionScrollModel } from '@/components/common/context/SectionScrollModelProvider';
import { ResponsiveImageSection, StaticImageSection } from '@/components/event/Sections';
import HelpGuide from '@/components/landing/HelpGuide';
import { LandingCtaButton } from '@/components/landing/LandingCtaButton';
import RefundFAQ from '@/components/landing/RefundFAQ';
import HomeLayout from '@/components/layout/HomeLayout';
import { CustomPageContentType } from '@/lib/types/custom-page';

export const CustomPageContent = ({ id, viewEvent, button, sections, defaultSection }: CustomPageContentType) => {
  const { screenType } = useSectionScrollModel();

  const getGradientProperty = (colors: string[]) => {
    if (!colors.length) return '';

    if (colors.length < 3) {
      return `${colors[0]} 0%, ${colors[1]} 100%`;
    }
    return `${colors[0]} 0%, ${colors[1]} 50%, ${colors[2]} 100%`;
  };

  return (
    <>
      <HomeLayout>
        {sections?.map(({ imageUrl, mobileImageUrl, backgroundColors }, idx) => {
          const background = backgroundColors.length > 1 ? `linear-gradient(180deg, ${getGradientProperty(backgroundColors)})` : backgroundColors[0];
          return mobileImageUrl ? (
            <ResponsiveImageSection
              key={`${id}-${idx}`}
              sectionId={`${idx + 1}`}
              imagePaths={{ mobile: mobileImageUrl, pc: imageUrl }}
              thresholds={{ mobile: 0.5, pc: 0.75 }}
              style={{ background }}
              maxWidth={'700'}
            />
          ) : (
            <StaticImageSection
              key={`${id}-${idx}`}
              sectionId={`${idx + 1}`}
              imagePath={imageUrl}
              threshold={screenType === 'mobile' ? 0.5 : 0.75}
              style={{ background }}
              maxWidth={'700'}
            />
          );
        })}
        {defaultSection?.faq && <RefundFAQ sectionId={`${sections.length + 1}`} maxWidth={'700'} />}
        {defaultSection?.help && <HelpGuide sectionId={`${sections.length + (defaultSection?.faq ? 2 : 1)}`} maxWidth={'700'} />}
      </HomeLayout>
      {button && (
        <LandingCtaButton style={{ backgroundColor: button.bgColor }} buttonText={button.label.replace(/>/g, '$>;')} buttonClickEvent={button.clickEvent} />
      )}
      {viewEvent && <PageViewEventLogger pageName={viewEvent} eventOption={{ isUseAirbridge: true, isUseGoogleAnalytics: true }} />}
    </>
  );
};
